import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {FieldName, IFrameColumn} from '@mintdata/mint-kit/api/values/frames/Frame';

export class AFrameColumn<T extends IValue> implements IFrameColumn<T>
{
    constructor(private _fieldName:FieldName,
                private _fieldType:Type,
                private _rows:T[])
    {
    }

    public get fieldName():FieldName
    {
        return this._fieldName;
    }

    public get fieldType():Type
    {
        return this._fieldType;
    }

    public get rows():T[]
    {
        return this._rows;
    }
}
